module.exports = __webpack_public_path__ + "img/chinesecompany66.a18cb6a8.png";